export const WorkHoursShouldCalcuated = (dayStatus) => {
    const normalized = (dayStatus || "").trim().toLowerCase();
    const result = !(normalized === "off" || normalized === "weekend" || normalized === "timecompensation");
    return result;
  };